import { useAppSelector } from "../../Redux/store"
import { ScreenResolver } from "../Resolvers/ScreenResolver"

export const Screen = () => {
    const { screen } = useAppSelector(state => state.screenInteractions)

    return (
            <div>
                <div className="pixel-corners px-8 py-4 bg-black">
                <div className="bg-red h-2 w-2 absolute left-10 z-20" style={{ top: 74, borderRadius: 2 }}/>
                <div id="screen" className="aspect-square bg-blue-light">
                    <ScreenResolver interactionScreen={screen}/>
                </div>
            </div>   
        </div>
    )
}

